function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import isObject from 'lodash/isObject';
import { useSelector } from 'react-redux';
import Button from 'components/Form/Button';
import XIcon from 'svg/x.svg';
import ErrorIcon from 'svg/error-mark.svg';
import { isMobileDisplayMode as isMobileDisplayModeSelector } from 'modules/App/selectors';
const Alert = ({ id, type, message, messageValues = {}, actions, onClose })=>{
    const isMobileDisplayMode = useSelector(isMobileDisplayModeSelector);
    const clickAction = (evt, actionFn)=>{
        evt.stopPropagation();
        actionFn();
        if (onClose) onClose();
    };
    const close = (evt)=>{
        evt.stopPropagation();
        if (onClose) onClose();
    };
    const renderIcon = ()=>{
        if (!isMobileDisplayMode || type !== 'error') return null;
        return /*#__PURE__*/ _jsx(ErrorIcon, {});
    };
    const renderContent = ()=>{
        if (isObject(message) && message.id) {
            const { id: messageId } = message, rest = _object_without_properties(message, [
                "id"
            ]);
            return /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: messageId,
                    // eslint-disable-next-line react/no-unstable-nested-components
                    values: _object_spread_props(_object_spread({}, messageValues, rest), {
                        b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                children: chunk
                            })
                    })
                })
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "alert_content",
            children: message
        });
    };
    const renderActions = ()=>{
        if (!actions) return null;
        return actions.map((action, index)=>/*#__PURE__*/ _jsx(Button, {
                className: "btn--sm btn--white alert_button",
                isDisabled: action.isDisabled,
                onClick: (evt)=>clickAction(evt, action.action),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, action.message))
            }, `alert-button-${action.message.id}-${id}-${index}`));
    };
    const renderCloseBtn = ()=>{
        if (!onClose || isMobileDisplayMode) return null;
        return /*#__PURE__*/ _jsx(XIcon, {
            className: "alert_close",
            onClick: close
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: `alert alert-${type}`,
        role: "alert",
        children: [
            renderIcon(),
            renderContent(),
            renderActions(),
            renderCloseBtn()
        ]
    });
};
export default Alert;
